export default __webpack_public_path__ + "static/media/take-medicines.606a86a8.png";